export const STORE_SVG_DEFS = `
<defs>
  <symbol id="clock" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.4"/>
    <path d="M8 4.5v4l2.5 1.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
  </symbol>
  <symbol id="arrow" viewBox="0 0 16 16">
    <path d="M5 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </symbol>
  <symbol id="clv" viewBox="-12 -12 24 24" overflow="visible">
    <g fill="currentColor">
      <ellipse cx="0" cy="-6" rx="5" ry="6"/>
      <ellipse cx="6" cy="0" rx="6" ry="5"/>
      <ellipse cx="0" cy="6" rx="5" ry="6"/>
      <ellipse cx="-6" cy="0" rx="6" ry="5"/>
      <rect x="-0.6" y="3" width="1.2" height="6" rx=".6" fill="#7a5a1e"/>
    </g>
  </symbol>
  <symbol id="spark" viewBox="-10 -10 20 20" overflow="visible">
    <g fill="currentColor">
      <path d="M0 -9 L1.2 -1.2 L9 0 L1.2 1.2 L0 9 L-1.2 1.2 L-9 0 L-1.2 -1.2 Z"/>
      <circle r="1.5" fill="#fff"/>
    </g>
  </symbol>

  <linearGradient id="gWarm" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0%" stop-color="#fff7d6"/>
    <stop offset="20%" stop-color="#fde6a8"/>
    <stop offset="45%" stop-color="#F8D870"/>
    <stop offset="68%" stop-color="#D9A442"/>
    <stop offset="88%" stop-color="#8a5a22"/>
    <stop offset="100%" stop-color="#3a2410"/>
  </linearGradient>
  <linearGradient id="gEdge" x1="0" y1="0" x2="1" y2="1">
    <stop offset="0%" stop-color="#fff4cc"/>
    <stop offset="30%" stop-color="#F8D870"/>
    <stop offset="60%" stop-color="#A87B2E"/>
    <stop offset="100%" stop-color="#5a3a18"/>
  </linearGradient>
  <linearGradient id="sDeep" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0%" stop-color="#ffffff"/>
    <stop offset="25%" stop-color="#dfe3ea"/>
    <stop offset="55%" stop-color="#9ca3ad"/>
    <stop offset="85%" stop-color="#5a6168"/>
    <stop offset="100%" stop-color="#1f242b"/>
  </linearGradient>
  <linearGradient id="brzDeep" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0%" stop-color="#f8d3a8"/>
    <stop offset="30%" stop-color="#d09a64"/>
    <stop offset="60%" stop-color="#8a5530"/>
    <stop offset="90%" stop-color="#4a2a14"/>
    <stop offset="100%" stop-color="#1a0e04"/>
  </linearGradient>
  <linearGradient id="dDeep" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0%" stop-color="#ffffff"/>
    <stop offset="25%" stop-color="#cdedff"/>
    <stop offset="55%" stop-color="#7ec4ee"/>
    <stop offset="85%" stop-color="#2e6e98"/>
    <stop offset="100%" stop-color="#0d3050"/>
  </linearGradient>
  <radialGradient id="gHalo" cx="50%" cy="50%" r="60%">
    <stop offset="0%" stop-color="#F8D870" stop-opacity=".55"/>
    <stop offset="40%" stop-color="#D9A442" stop-opacity=".18"/>
    <stop offset="100%" stop-color="#A87B2E" stop-opacity="0"/>
  </radialGradient>
  <radialGradient id="dHalo" cx="50%" cy="50%" r="60%">
    <stop offset="0%" stop-color="#a7dff5" stop-opacity=".55"/>
    <stop offset="50%" stop-color="#3f8cba" stop-opacity=".15"/>
    <stop offset="100%" stop-color="#0d3050" stop-opacity="0"/>
  </radialGradient>
  <linearGradient id="specV" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0%" stop-color="#ffffff" stop-opacity=".7"/>
    <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
  </linearGradient>
  <filter id="bloom" x="-50%" y="-50%" width="200%" height="200%">
    <feGaussianBlur stdDeviation="1.5" result="b"/>
    <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
  </filter>
  <filter id="soft"><feGaussianBlur stdDeviation="2"/></filter>
  <filter id="ds2" x="-30%" y="-30%" width="160%" height="160%">
    <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#000" flood-opacity=".55"/>
  </filter>

  <symbol id="art-vault" viewBox="0 0 160 120">
    <circle cx="80" cy="60" r="58" fill="url(#gHalo)"/>
    <ellipse cx="80" cy="105" rx="48" ry="4" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)" transform="translate(80,60)">
      <circle r="48" fill="#3a2410"/><circle r="46" fill="url(#gWarm)"/>
      <circle r="42" fill="#0a1810"/>
      <circle r="42" fill="url(#specV)" opacity=".12"/>
      <path d="M-44 -8 A 48 48 0 0 1 30 -42" stroke="rgba(255,255,255,.5)" stroke-width="1.8" fill="none" stroke-linecap="round"/>
      <g>
        <circle cx="0" cy="-38" r="3.2" fill="#5a3a18"/><circle cx="0" cy="-38.5" r="2.8" fill="url(#gEdge)"/>
        <circle cx="38" cy="0" r="3.2" fill="#5a3a18"/><circle cx="38" cy="-.5" r="2.8" fill="url(#gEdge)"/>
        <circle cx="0" cy="38" r="3.2" fill="#5a3a18"/><circle cx="0" cy="37.5" r="2.8" fill="url(#gEdge)"/>
        <circle cx="-38" cy="0" r="3.2" fill="#5a3a18"/><circle cx="-38" cy="-.5" r="2.8" fill="url(#gEdge)"/>
        <circle cx="27" cy="-27" r="2.6" fill="#5a3a18"/><circle cx="27" cy="-27.4" r="2.2" fill="url(#gEdge)"/>
        <circle cx="27" cy="27" r="2.6" fill="#5a3a18"/><circle cx="27" cy="26.6" r="2.2" fill="url(#gEdge)"/>
        <circle cx="-27" cy="-27" r="2.6" fill="#5a3a18"/><circle cx="-27" cy="-27.4" r="2.2" fill="url(#gEdge)"/>
        <circle cx="-27" cy="27" r="2.6" fill="#5a3a18"/><circle cx="-27" cy="26.6" r="2.2" fill="url(#gEdge)"/>
      </g>
      <circle r="32" fill="none" stroke="#5a3a18" stroke-width="2.5"/><circle r="32" fill="none" stroke="url(#gWarm)" stroke-width="1.8"/>
      <circle r="22" fill="#3a2410"/><circle r="22" fill="url(#gWarm)"/><circle r="19" fill="#0a1810"/>
      <g stroke="url(#gEdge)" stroke-width="4" stroke-linecap="round">
        <line x1="0" y1="-13" x2="0" y2="-25"/><line x1="13" y1="0" x2="25" y2="0"/>
        <line x1="0" y1="13" x2="0" y2="25"/><line x1="-13" y1="0" x2="-25" y2="0"/>
      </g>
      <circle r="9" fill="#5a3a18"/><circle r="8" fill="url(#gWarm)"/>
      <g color="#3a2410"><use href="#clv" width="10" height="10" x="-5" y="-5"/></g>
      <ellipse cx="-3" cy="-4" rx="3" ry="1.2" fill="#fff" opacity=".55" transform="rotate(-30 -3 -4)"/>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="14" y="14" width="6" height="6"/>
      <use href="#spark" x="138" y="20" width="5" height="5"/>
      <use href="#spark" x="142" y="86" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-trophy" viewBox="0 0 160 120">
    <ellipse cx="80" cy="62" rx="42" ry="48" fill="url(#gHalo)" opacity=".75"/>
    <ellipse cx="80" cy="104" rx="28" ry="2.5" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="58" y="94" width="44" height="8" rx="1.5" fill="#3a2410"/>
      <rect x="58" y="93" width="44" height="6" rx="1" fill="url(#gWarm)"/>
      <rect x="66" y="86" width="28" height="8" rx="1" fill="#3a2410"/>
      <rect x="66" y="85" width="28" height="6" rx="1" fill="url(#gWarm)"/>
      <rect x="73" y="73" width="14" height="13" fill="#3a2410"/>
      <rect x="73" y="73" width="14" height="13" fill="url(#gWarm)"/>
      <path d="M 54 28 L 106 28 L 102 65 Q 80 82 58 65 Z" fill="#3a2410"/>
      <path d="M 55 29 L 105 29 L 101 64 Q 80 80 59 64 Z" fill="url(#gWarm)"/>
      <rect x="52" y="26" width="56" height="6" rx="1.5" fill="#3a2410"/>
      <rect x="52" y="26" width="56" height="6" rx="1.5" fill="url(#gEdge)"/>
      <rect x="52" y="26" width="56" height="2" fill="#fff7d6" opacity=".6"/>
      <path d="M 54 34 Q 38 36 38 50 Q 38 62 56 64" fill="none" stroke="#3a2410" stroke-width="6" stroke-linecap="round"/>
      <path d="M 54 34 Q 39 36 39 50 Q 39 62 56 64" fill="none" stroke="url(#gWarm)" stroke-width="4" stroke-linecap="round"/>
      <path d="M 106 34 Q 122 36 122 50 Q 122 62 104 64" fill="none" stroke="#3a2410" stroke-width="6" stroke-linecap="round"/>
      <path d="M 106 34 Q 121 36 121 50 Q 121 62 104 64" fill="none" stroke="url(#gWarm)" stroke-width="4" stroke-linecap="round"/>
      <circle cx="80" cy="52" r="11" fill="#3a2410" opacity=".4"/>
      <g color="#3a2410"><use href="#clv" width="18" height="18" x="71" y="43"/></g>
      <path d="M 60 32 Q 58 55 68 70" stroke="rgba(255,255,255,.55)" stroke-width="3" fill="none" stroke-linecap="round"/>
      <path d="M 100 32 Q 100 52 96 65" stroke="rgba(255,255,255,.3)" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="40" y="14" width="6" height="6"/>
      <use href="#spark" x="118" y="18" width="6" height="6"/>
      <use href="#spark" x="76" y="6" width="5" height="5"/>
      <use href="#spark" x="22" y="38" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-ticket" viewBox="0 0 160 120">
    <ellipse cx="80" cy="60" rx="62" ry="34" fill="url(#gHalo)" opacity=".7"/>
    <g filter="url(#ds2)" transform="rotate(-7 80 60)">
      <path d="M 30 36 L 118 36 Q 122 36 122 40 L 122 50 Q 116 52 116 60 Q 116 68 122 70 L 122 80 Q 122 84 118 84 L 30 84 Q 26 84 26 80 L 26 70 Q 32 68 32 60 Q 32 52 26 50 L 26 40 Q 26 36 30 36 Z" fill="#3a2410"/>
      <path d="M 31 37 L 117 37 Q 121 37 121 41 L 121 49.5 Q 115 51.5 115 60 Q 115 68.5 121 70.5 L 121 79 Q 121 83 117 83 L 31 83 Q 27 83 27 79 L 27 70.5 Q 33 68.5 33 60 Q 33 51.5 27 49.5 L 27 41 Q 27 37 31 37 Z" fill="url(#gWarm)"/>
      <line x1="74" y1="42" x2="74" y2="78" stroke="#5a3a18" stroke-width="1.2" stroke-dasharray="2 2"/>
      <circle cx="50" cy="60" r="13" fill="#5a3a18" opacity=".25"/>
      <g color="#3a2410"><use href="#clv" width="22" height="22" x="39" y="49"/></g>
      <path d="M 30 37 L 118 37 Q 121 37 121 40 L 121 44 L 28 44 L 28 40 Q 28 37 30 37 Z" fill="url(#specV)" opacity=".5"/>
      <path d="M 30 36 L 118 36 Q 122 36 122 40 L 122 50 Q 116 52 116 60 Q 116 68 122 70 L 122 80 Q 122 84 118 84 L 30 84 Q 26 84 26 80 L 26 70 Q 32 68 32 60 Q 32 52 26 50 L 26 40 Q 26 36 30 36 Z" fill="none" stroke="#5a3a18" stroke-width="1"/>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="20" y="20" width="5" height="5"/>
      <use href="#spark" x="132" y="92" width="5" height="5"/>
    </g>
  </symbol>
  <symbol id="art-bronze" viewBox="0 0 160 120">
    <ellipse cx="80" cy="68" rx="56" ry="38" fill="url(#gHalo)" opacity=".7"/>
    <ellipse cx="80" cy="103" rx="50" ry="4" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="36" y="55" width="88" height="42" rx="3" fill="#1a0e04"/>
      <rect x="38" y="55" width="84" height="42" rx="3" fill="url(#brzDeep)"/>
      <rect x="36" y="63" width="88" height="6" fill="url(#gWarm)"/>
      <rect x="36" y="63" width="88" height="2" fill="#fff7d6" opacity=".5"/>
      <path d="M 36 55 Q 36 30 80 30 Q 124 30 124 55 Z" fill="#1a0e04"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55 Z" fill="url(#brzDeep)"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55" fill="none" stroke="url(#gWarm)" stroke-width="2"/>
      <path d="M 42 52 Q 42 36 70 33" stroke="rgba(255,255,255,.5)" stroke-width="2.5" fill="none" stroke-linecap="round"/>
      <rect x="71" y="56" width="18" height="22" rx="2" fill="#1a0e04"/>
      <rect x="72" y="57" width="16" height="20" rx="1.5" fill="url(#gWarm)"/>
      <circle cx="80" cy="67" r="4.5" fill="#1a0e04"/>
      <g color="#F8D870" transform="translate(80,67)"><use href="#clv" width="7" height="7" x="-3.5" y="-3.5"/></g>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="20" y="22" width="5" height="5"/>
      <use href="#spark" x="136" y="28" width="6" height="6"/>
      <use href="#spark" x="128" y="78" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-silver" viewBox="0 0 160 120">
    <ellipse cx="80" cy="68" rx="56" ry="38" fill="url(#gHalo)" opacity=".7"/>
    <ellipse cx="80" cy="103" rx="50" ry="4" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="36" y="55" width="88" height="42" rx="3" fill="#1f242b"/>
      <rect x="38" y="55" width="84" height="42" rx="3" fill="url(#sDeep)"/>
      <rect x="36" y="63" width="88" height="6" fill="url(#gWarm)"/>
      <rect x="36" y="63" width="88" height="2" fill="#fff7d6" opacity=".5"/>
      <path d="M 36 55 Q 36 30 80 30 Q 124 30 124 55 Z" fill="#1f242b"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55 Z" fill="url(#sDeep)"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55" fill="none" stroke="url(#gWarm)" stroke-width="2"/>
      <path d="M 42 52 Q 42 36 70 33" stroke="rgba(255,255,255,.5)" stroke-width="2.5" fill="none" stroke-linecap="round"/>
      <rect x="71" y="56" width="18" height="22" rx="2" fill="#1f242b"/>
      <rect x="72" y="57" width="16" height="20" rx="1.5" fill="url(#gWarm)"/>
      <circle cx="80" cy="67" r="4.5" fill="#1a0e04"/>
      <g color="#F8D870" transform="translate(80,67)"><use href="#clv" width="7" height="7" x="-3.5" y="-3.5"/></g>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="20" y="22" width="5" height="5"/>
      <use href="#spark" x="136" y="28" width="6" height="6"/>
      <use href="#spark" x="128" y="78" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-gold" viewBox="0 0 160 120">
    <ellipse cx="80" cy="68" rx="56" ry="38" fill="url(#gHalo)" opacity=".7"/>
    <ellipse cx="80" cy="103" rx="50" ry="4" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="36" y="55" width="88" height="42" rx="3" fill="#3a2410"/>
      <rect x="38" y="55" width="84" height="42" rx="3" fill="url(#gWarm)"/>
      <rect x="36" y="63" width="88" height="6" fill="url(#gWarm)"/>
      <rect x="36" y="63" width="88" height="2" fill="#fff7d6" opacity=".5"/>
      <path d="M 36 55 Q 36 30 80 30 Q 124 30 124 55 Z" fill="#3a2410"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55 Z" fill="url(#gWarm)"/>
      <path d="M 38 55 Q 38 32 80 32 Q 122 32 122 55" fill="none" stroke="url(#gWarm)" stroke-width="2"/>
      <path d="M 42 52 Q 42 36 70 33" stroke="rgba(255,255,255,.5)" stroke-width="2.5" fill="none" stroke-linecap="round"/>
      <rect x="71" y="56" width="18" height="22" rx="2" fill="#3a2410"/>
      <rect x="72" y="57" width="16" height="20" rx="1.5" fill="url(#gWarm)"/>
      <circle cx="80" cy="67" r="4.5" fill="#1a0e04"/>
      <g color="#F8D870" transform="translate(80,67)"><use href="#clv" width="7" height="7" x="-3.5" y="-3.5"/></g>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="20" y="22" width="5" height="5"/>
      <use href="#spark" x="136" y="28" width="6" height="6"/>
      <use href="#spark" x="128" y="78" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-crown" viewBox="0 0 160 120">
    <ellipse cx="80" cy="58" rx="56" ry="40" fill="url(#gHalo)" opacity=".75"/>
    <ellipse cx="80" cy="100" rx="42" ry="3" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="38" y="76" width="84" height="12" rx="2" fill="#3a2410"/>
      <rect x="38" y="76" width="84" height="10" rx="2" fill="url(#gWarm)"/>
      <rect x="38" y="76" width="84" height="3" fill="#fff7d6" opacity=".5"/>
      <path d="M 38 78 L 50 50 L 62 70 L 80 32 L 98 70 L 110 50 L 122 78 Z" fill="#3a2410"/>
      <path d="M 39 78 L 51 51 L 62 69 L 80 34 L 98 69 L 109 51 L 121 78 Z" fill="url(#gWarm)"/>
      <polygon points="80,30 84,36 80,42 76,36" fill="url(#dDeep)"/>
      <path d="M 42 76 Q 44 60 60 56" stroke="rgba(255,255,255,.5)" stroke-width="2" fill="none" stroke-linecap="round"/>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="76" y="14" width="6" height="6"/>
      <use href="#spark" x="22" y="42" width="5" height="5"/>
      <use href="#spark" x="134" y="42" width="5" height="5"/>
    </g>
  </symbol>
  <symbol id="art-diamond" viewBox="0 0 160 120">
    <circle cx="80" cy="58" r="50" fill="url(#dHalo)"/>
    <g filter="url(#ds2)" transform="translate(80,58)">
      <polygon points="-34,-12 -19,-24 19,-24 34,-12" fill="url(#dDeep)"/>
      <polygon points="-19,-24 -10,-24 -19,-12 -34,-12" fill="#ffffff" opacity=".55"/>
      <line x1="-34" y1="-12" x2="34" y2="-12" stroke="#0d3050" stroke-width=".9"/>
      <line x1="-19" y1="-24" x2="-19" y2="-12" stroke="#0d3050" stroke-width=".9"/>
      <line x1="0" y1="-24" x2="0" y2="-12" stroke="#0d3050" stroke-width=".9"/>
      <line x1="19" y1="-24" x2="19" y2="-12" stroke="#0d3050" stroke-width=".9"/>
      <polygon points="-34,-12 34,-12 0,34" fill="url(#dDeep)"/>
      <polygon points="-34,-12 -10,-12 0,34" fill="#ffffff" opacity=".07"/>
      <polygon points="10,-12 34,-12 0,34" fill="#0d3050" opacity=".12"/>
      <line x1="-34" y1="-12" x2="0" y2="34" stroke="#0d3050" stroke-width=".9"/>
      <line x1="-17" y1="-12" x2="0" y2="34" stroke="#0d3050" stroke-width=".6" opacity=".7"/>
      <line x1="0" y1="-12" x2="0" y2="34" stroke="#0d3050" stroke-width=".6" opacity=".7"/>
      <line x1="17" y1="-12" x2="0" y2="34" stroke="#0d3050" stroke-width=".6" opacity=".7"/>
      <line x1="34" y1="-12" x2="0" y2="34" stroke="#0d3050" stroke-width=".9"/>
      <polygon points="-24,-22 -14,-22 -24,-12 -34,-12" fill="#fff" opacity=".7"/>
      <rect x="-14" y="-22" width="28" height="2" fill="#fff" opacity=".55"/>
    </g>
    <g color="#cdedff" filter="url(#bloom)">
      <use href="#spark" x="14" y="16" width="7" height="7"/>
      <use href="#spark" x="138" y="22" width="6" height="6"/>
      <use href="#spark" x="124" y="80" width="5" height="5"/>
      <use href="#spark" x="32" y="92" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-spins" viewBox="0 0 160 120">
    <circle cx="80" cy="60" r="62" fill="url(#gHalo)"/>
    <ellipse cx="80" cy="104" rx="56" ry="3" fill="rgba(0,0,0,.6)" filter="url(#soft)"/>
    <g filter="url(#ds2)">
      <rect x="20" y="22" width="120" height="76" rx="11" fill="url(#gWarm)"/>
      <rect x="22" y="24" width="116" height="72" rx="9" fill="none" stroke="#3a2410" stroke-width="2" opacity=".7"/>
      <rect x="26" y="28" width="108" height="64" rx="6" fill="#050a08"/>
      <rect x="22" y="24" width="116" height="14" rx="9" fill="url(#specV)" opacity=".55"/>
      <rect x="32" y="34" width="28" height="52" rx="4" fill="#0a1810"/>
      <rect x="32" y="34" width="28" height="52" rx="4" fill="url(#specV)" opacity=".10"/>
      <rect x="66" y="34" width="28" height="52" rx="4" fill="#0a1810"/>
      <rect x="66" y="34" width="28" height="52" rx="4" fill="url(#specV)" opacity=".10"/>
      <rect x="100" y="34" width="28" height="52" rx="4" fill="#0a1810"/>
      <rect x="100" y="34" width="28" height="52" rx="4" fill="url(#specV)" opacity=".10"/>
      <g color="#F8D870" transform="translate(46,46)"><use href="#clv" width="14" height="14" x="-7" y="-7"/></g>
      <circle cx="46" cy="60" r="6" fill="url(#gEdge)" stroke="#7a5a1e" stroke-width=".5"/>
      <text x="46" y="64" text-anchor="middle" font-family="Bebas Neue,sans-serif" font-size="9" fill="#3a2410" font-weight="700">7</text>
      <g color="#F8D870" transform="translate(46,76)"><use href="#clv" width="11" height="11" x="-5.5" y="-5.5"/></g>
      <circle cx="80" cy="46" r="6" fill="url(#gEdge)" stroke="#7a5a1e" stroke-width=".5"/>
      <g color="#F8D870" transform="translate(80,60)"><use href="#clv" width="14" height="14" x="-7" y="-7"/></g>
      <circle cx="80" cy="76" r="5" fill="url(#gEdge)" stroke="#7a5a1e" stroke-width=".5"/>
      <g color="#F8D870" transform="translate(114,46)"><use href="#clv" width="11" height="11" x="-5.5" y="-5.5"/></g>
      <circle cx="114" cy="60" r="6" fill="url(#gEdge)" stroke="#7a5a1e" stroke-width=".5"/>
      <g color="#F8D870" transform="translate(114,76)"><use href="#clv" width="14" height="14" x="-7" y="-7"/></g>
      <rect x="28" y="57" width="104" height="6" rx="2" fill="rgba(248,216,112,.3)" filter="url(#bloom)"/>
      <rect x="28" y="58" width="104" height="3" rx="1" fill="#fff4cc" opacity=".65"/>
      <g fill="url(#gEdge)" stroke="#3a2410" stroke-width=".3">
        <circle cx="26" cy="32" r="1.6"/><circle cx="134" cy="32" r="1.6"/>
        <circle cx="26" cy="88" r="1.6"/><circle cx="134" cy="88" r="1.6"/>
      </g>
    </g>
    <g color="#fff4cc" filter="url(#bloom)" opacity=".85">
      <use href="#spark" x="-3" y="16" width="6" height="6"/>
      <use href="#spark" x="148" y="20" width="5" height="5"/>
      <use href="#spark" x="6" y="92" width="4" height="4"/>
    </g>
  </symbol>
  <symbol id="art-coins" viewBox="0 0 160 120">
    <circle cx="80" cy="68" r="58" fill="url(#gHalo)"/>
    <ellipse cx="80" cy="105" rx="46" ry="4" fill="rgba(0,0,0,.55)" filter="url(#soft)"/>
    <g filter="url(#ds2)" transform="translate(80,80)">
      <ellipse cx="-15" cy="12" rx="36" ry="10" fill="#5a3a18"/>
      <ellipse cx="-15" cy="11" rx="36" ry="10" fill="url(#gEdge)"/>
      <ellipse cx="-15" cy="9" rx="34" ry="9" fill="url(#gWarm)"/>
      <ellipse cx="8" cy="2" rx="36" ry="10.5" fill="#5a3a18"/>
      <ellipse cx="8" cy="1" rx="36" ry="10.5" fill="url(#gEdge)"/>
      <ellipse cx="8" cy="-1" rx="34" ry="9.5" fill="url(#gWarm)"/>
      <ellipse cx="-4" cy="-7" rx="35" ry="10" fill="#5a3a18"/>
      <ellipse cx="-4" cy="-8" rx="35" ry="10" fill="url(#gEdge)"/>
      <ellipse cx="-4" cy="-10" rx="33" ry="9" fill="url(#gWarm)"/>
      <g transform="translate(18,-32)">
        <circle r="24" fill="#5a3a18"/>
        <circle r="22" fill="url(#gEdge)"/>
        <circle r="20" fill="url(#gWarm)"/>
        <circle r="17" fill="none" stroke="#5a3a18" stroke-width=".8" opacity=".5"/>
        <circle r="15" fill="none" stroke="#fff7d6" stroke-width=".5" opacity=".4"/>
        <g color="#5a3a18"><use href="#clv" width="18" height="18" x="-9" y="-9"/></g>
        <ellipse cx="-9" cy="-13" rx="8" ry="3" fill="#fff" opacity=".55" transform="rotate(-30 -9 -13)"/>
        <ellipse cx="11" cy="13" rx="4" ry="1.5" fill="#fff" opacity=".25" transform="rotate(-30 11 13)"/>
        <path d="M -18 -14 A 22 22 0 0 1 8 -22" stroke="rgba(255,255,255,.4)" stroke-width="1.5" fill="none" stroke-linecap="round"/>
      </g>
    </g>
    <g color="#fff4cc" filter="url(#bloom)">
      <use href="#spark" x="116" y="14" width="6" height="6"/>
      <use href="#spark" x="22" y="22" width="5" height="5"/>
      <use href="#spark" x="130" y="78" width="4" height="4"/>
      <circle cx="14" cy="60" r="1.2" fill="#fff" opacity=".7"/>
      <circle cx="140" cy="48" r="1" fill="#fff" opacity=".6"/>
    </g>
  </symbol>
</defs>
`;
